"use client"

import TEBreadcrumb from "@/components/common/TEBreadcrumb"
import { useTour } from "@/hooks/tour/useTour"
import { useToursCategories } from "@/hooks/tour/useToursCategories"
import { faHomeAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useSearchParams } from "next/navigation"
import { useMemo } from "react"
import { useTranslation } from "react-i18next"

const TourDetailBreadcrumb = () => {
  const { tour: { data: tour } } = useTour()
  const { data: { tourCategories } } = useToursCategories()
  const searchParams = useSearchParams()
  const categoryId = searchParams.get("categoryId")
  const tourCategory = useMemo(() => {
    return tourCategories.find(t => t.id === categoryId)
  }, [categoryId])
  const { t } = useTranslation()

  return (
    <TEBreadcrumb
      style={{ marginBlock: '1rem' }}
      items={[
        {
          path: "/tours",
          title: (
            <>
              <FontAwesomeIcon icon={faHomeAlt} />
              <span>
                {t("common.home")}
              </span>
            </>
          ),
        },
        {
          path: `/tours/category/${tourCategory?.id || ""}`,
          title: (
            <>
              <span>
                {tourCategory?.name || ""}
              </span>
            </>
          ),
        },
        {
          path: `/tours/collection/${tour.categoryId}/detail/${tour.tourId}?${searchParams.toString()}`,
          title: (
            <>
              <span>
                {tour.name}
              </span>
            </>
          ),
        }
      ]}
    />
  )
}

export default TourDetailBreadcrumb